<div class="agd">
  <div class="agd-top">
    <h2>Explore {{ data.networkName }} {{ data.groupsLabel | lowercase }}</h2>
    <button type="button" class="agd-close" (click)="close()" aria-label="Close dialog">
      <span class="material-icons">close</span>
    </button>
  </div>
  <p class="agd-desc">Move from network-wide discovery into an individual {{ data.groupsLabel | lowercase }} context while keeping your profile.</p>
  <div class="agd-grid">
    <button type="button" class="agd-option" [class.agd-option--active]="isActive(null)" (click)="pick(null)">
      <span class="agd-initial">✦</span>
      <span class="agd-name">All {{ data.groupsLabel }}</span>
      <span *ngIf="isActive(null)" class="material-icons agd-check">check</span>
    </button>
    <button type="button" *ngFor="let group of data.groups" class="agd-option"
      [class.agd-option--active]="isActive(group)" [title]="groupName(group)" (click)="pick(group)">
      <img *ngIf="logo(group)" [src]="logo(group)" class="agd-logo" alt="" />
      <span *ngIf="!logo(group)" class="agd-initial">{{ (groupName(group) || '?').charAt(0) }}</span>
      <span class="agd-name">{{ groupName(group) }}</span>
      <span *ngIf="isActive(group)" class="material-icons agd-check">check</span>
    </button>
  </div>
</div>
